import { render, staticRenderFns } from "./MyPeople.vue?vue&type=template&id=2b82b442&scoped=true"
import script from "./MyPeople.vue?vue&type=script&lang=js"
export * from "./MyPeople.vue?vue&type=script&lang=js"
import style0 from "./MyPeople.vue?vue&type=style&index=0&id=2b82b442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82b442",
  null
  
)

export default component.exports